import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.CustomerRosterPage.title',
    defaultMessage: 'Roster'
  },
  subtitle: {
    id: 'containers.CustomerRosterPage.featuredVoiceTalents',
    defaultMessage: 'These voice talents have been hand picked to feature on your roster. Review and listen below.',
  },
  description: {
    id: 'containers.CustomerRosterPage.filter.description',
    defaultMessage: 'Description'
  },
  gender: {
    id: 'containers.CustomerRosterPage.filter.gender',
    defaultMessage: 'Gender'
  },
  languages: {
    id: 'containers.CustomerRosterPage.filter.languages',
    defaultMessage: 'Languages'
  },
  dialects: {
    id: 'containers.CustomerRosterPage.filter.dialects',
    defaultMessage: 'Dialects'
  },
  voiceAge: {
    id: 'containers.CustomerRosterPage.filter.voiceAge',
    defaultMessage: 'Voice Age'
  },
})
